import ErrorPage from '@/components/ErrorBoundary/ErrorPage'
import { RouteObject } from 'react-router-dom'

const NotFoundModule: RouteObject = {
    path: '*',
    element: <ErrorPage status={404} />,
}

export default NotFoundModule
